<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" *ngIf="formData">
  <div class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[92vh] animate-fade-in-up">

    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">credit_card</span>
          {{ configId ? 'แก้ไข Whitelist ประเภทบัตร' : 'สร้าง Whitelist ประเภทบัตร' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          กำหนดประเภทบัตรและ Subscription สำหรับลานที่เลือก
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-5">
      <div class="p-4 rounded-2xl bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/60 dark:border-amber-500/30">
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ลาน (Site) *</label>
        <div class="text-sm font-bold text-slate-800 dark:text-slate-100">
          {{ siteName || siteState.selectedSite()?.name || ('Site ID ' + siteId) }}
        </div>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">อิงจากลานที่เลือกใน Sidebar — ไม่สามารถตั้งเป็น "ทุกลาน" ได้</p>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ชื่อ (optional)</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">label</span>
          <input [(ngModel)]="formData.name" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          ประเภทบัตร <span class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">credit_card</span>
          <select [(ngModel)]="formData.cardTypeId" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
            <option [ngValue]="0">-- เลือกประเภทบัตร --</option>
            <option *ngFor="let t of cardTypes" [ngValue]="t.id">{{ t.name }}</option>
          </select>
        </div>
      </div>

      <div class="relative z-20">
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          Subscription <span class="text-rose-500">*</span>
        </label>
        <p class="text-xs text-slate-500 dark:text-slate-400 mb-2">ต้องระบุ Subscription ของลานนี้ — ใช้กำหนดบัตรฟรี/โควต้าให้ชัดเจน</p>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">subscriptions</span>
          <input type="text" [(ngModel)]="subscriptionSearchText" (focus)="openSubscriptionDropdown()" (input)="onSubscriptionSearchInput()"
            (blur)="closeSubscriptionDropdown()" [disabled]="!siteId || isSaving()"
            placeholder="ค้นหาและเลือก Subscription..."
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
        </div>
        <button *ngIf="isSubscriptionDropdownOpen" type="button" class="fixed inset-0 z-30 cursor-default"
          (click)="closeSubscriptionDropdown()"></button>
        <div *ngIf="isSubscriptionDropdownOpen"
          class="absolute top-full mt-2 left-0 right-0 max-h-52 overflow-y-auto bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-40 custom-scrollbar">
          <button *ngFor="let s of subscriptionDropdownOptions" type="button" (mousedown)="$event.preventDefault(); selectSubscription(s)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors">
            {{ s.name }} <span class="text-xs text-slate-400">(ID {{ s.id }})</span>
          </button>
          <div *ngIf="subscriptionDropdownOptions.length === 0" class="px-4 py-3 text-sm text-slate-400">ไม่พบ Subscription ของลานนี้</div>
          <div *ngIf="!subscriptionSearchText.trim() && subscriptions.length > 20" class="px-4 py-2 text-xs text-slate-400 border-t border-slate-100 dark:border-slate-700">
            แสดง 20 รายการแรก (เรียงตาม ID) — พิมพ์เพื่อค้นหาเพิ่ม
          </div>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          Card Scope <span class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">category</span>
          <select [(ngModel)]="formData.cardScope" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
            <option *ngFor="let s of scopeOptions" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">ออกบัตรโควต้า (path 52) ใช้ scope <strong>free</strong> หรือ <strong>both</strong></p>
      </div>

      <div class="p-4 rounded-2xl border border-amber-200/60 dark:border-amber-500/30 bg-amber-50/40 dark:bg-amber-500/10">
        <label class="inline-flex items-start gap-3 cursor-pointer select-none">
          <input type="checkbox" id="managed" class="mt-1 w-5 h-5 rounded border-slate-300 text-amber-500 focus:ring-amber-200"
            [(ngModel)]="formData.managedByPlatform" [disabled]="isSaving()">
          <span class="text-sm">
            <span class="font-bold text-slate-800 dark:text-slate-100">Managed by Platform (เข้าระบบโควต้า)</span>
            <p class="text-xs text-amber-800/80 dark:text-amber-200/80 mt-1 font-medium">
              เปิด = ประเภทบัตรนี้แสดงในเมนูออกบัตรโควต้า (52) และต้องมี quota ก่อนออกบัตร
            </p>
          </span>
        </label>
      </div>

      <label class="inline-flex items-center gap-3 cursor-pointer select-none">
        <input type="checkbox" id="enable" class="w-5 h-5 rounded border-slate-300 text-amber-500 focus:ring-amber-200"
          [(ngModel)]="formData.enable" [disabled]="isSaving()">
        <span class="text-sm font-bold text-slate-700 dark:text-slate-200">เปิดใช้งาน</span>
      </label>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-end gap-3 bg-white/95 dark:bg-slate-900/95">
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        ยกเลิก
      </button>
      <button type="button" (click)="onSave()" [disabled]="isSaving()"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
  </div>
</div>
